<template>
  <div v-if="showGenericStickyHeader" class="generic-sticky-header" :style="{ border: initialData.backgroundcolor !== '#FFFFFF' ?  `1px solid ${initialData.backgroundcolor}` : '' }">
    <div class="generic-sticky-header__container" :style="{ backgroundColor: initialData.backgroundcolor }">
      <a v-if="!initialData.disablefullcta" :href="initialData.ctalink" class="generic-sticky-header__cta full__cta" :style="{color: initialData.textcolor}" v-html="initialData.headercontent" @click="closeStickyBar(true)"></a>
      <p v-else class="generic-sticky-header__cta" :style="{color: initialData.textcolor}" v-html="initialData.headercontent"></p>      
      <button id="btn_close" class="btn_close close" :aria-label="close" @click="closeStickyBar(false)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1514 12L3.57569 19.5757L4.42422 20.4242L11.9999 12.8485L19.5757 20.4242L20.4242 19.5757L12.8485 12L20.4242 4.42421L19.5757 3.57568L11.9999 11.1514L4.42421 3.57569L3.57568 4.42422L11.1514 12Z" :fill="initialData.textcolor"/>
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'generic-sticky-header',
  props: {
    initialData: {
      type: Object,
      default: {}
    },
    pageCategory: {
      type: String,
      default:''
    },
    close: {
      type: String,
      default:''
    },
  },
  data() {
    return {
      showGenericStickyHeader: true
    };
  },
  created() {
    this.initialRendering();
  },
  methods: {
    closeStickyBar(flag) {
      if (flag) {
        let event = { 
          ...this.initialData.tagging,
          pageCategory: window.wsf.pageCategory
        };
        window.dataLayer.push(event);
      }
      this.showGenericStickyHeader = false;
      document.cookie = 'genericStickyHeader=true';
    },
    initialRendering() {
      const getStickyCookie = document.cookie
      .split(';')
      .filter((cookieItem) => cookieItem.includes('genericStickyHeader'));
      this.showGenericStickyHeader = !getStickyCookie.length;
    }
  }
};
</script>
<style lang='scss' src="./generic-sticky-header.scss"></style>

